import Iconify from "@/components/ui/Iconify";
import Span from "@/components/ui/Span";

const CustomWarningTextInput = ({
    name,
    value,
    onChange,
    placeholder,
    type,
    className = "",
    showEmptyError = false,
    icon,
    warningIcon,
    emptyErrorMsg,
    inputMainClass
}) => {
    return (
        <div className="w-full">
            <div className={`flex gap-4 items-center border rounded-full px-5 py-2 dark:bg-[#0E0E0E] ${showEmptyError && value === "" ? "border-red" : "dark:border-gray-600"} ${inputMainClass}`}>
                {
                    icon &&
                    <Iconify icon={icon} className="!w-7 !h-7" />
                }
                <input
                    autoComplete="none"
                    name={name}
                    className={`px-4 py-0 sm:py-1.5 dark:bg-inherit  border-l ${showEmptyError && value === "" ? "border-red" : "dark:border-gray-600"}  w-full placeholder:dark:text-neutral-500 transition duration-300 ${className} outline-none`}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    type={type}
                />
                {
                    warningIcon && showEmptyError && value === "" &&
                    <Iconify icon={warningIcon} className="!w-7 !h-7 !text-red" />
                }

            </div>
            <Span className={`!text-red px-1 ${(showEmptyError && value === "") ? "block" : "hidden"}`}>{emptyErrorMsg}</Span>
        </div>
    );
};

export default CustomWarningTextInput;
